import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {ButtonModule} from '../button/button.module';
import {DownloadButtonComponent} from './download-button.component';
import {PdfPreviewModalModule} from '../pdf-preview-modal/pdf-preview-modal.module';

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        ButtonModule,
        PdfPreviewModalModule
    ],
    declarations: [
        DownloadButtonComponent
    ],
    exports: [
        DownloadButtonComponent
    ],
})
export class DownloadButtonModule {
}
